<div class="container" [class.is_mobile]="isMobile">

  <!-- Header da página -->
  <div class="page-header">
    <div class="page-header-icon">
      <!-- Phosphor: IdentificationCard duotone -->
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#4d8241" viewBox="0 0 256 256">
        <path d="M240,56V200a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V56A16,16,0,0,1,32,40H224A16,16,0,0,1,240,56Z" opacity="0.2"/>
        <path d="M224,40H32A24,24,0,0,0,8,64V192a24,24,0,0,0,24,24H224a24,24,0,0,0,24-24V64A24,24,0,0,0,224,40Zm8,152a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8ZM88,144a32,32,0,1,0-32-32A32,32,0,0,0,88,144Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,88,128Zm-8,56H96a48.05,48.05,0,0,1,48,48,8,8,0,0,1-16,0,32,32,0,0,0-32-32H80a32,32,0,0,0-32,32,8,8,0,0,1-16,0A48.05,48.05,0,0,1,80,184Zm120-56H168a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Zm0,32H168a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Zm0,32H168a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Z"/>
      </svg>
    </div>
    <div class="page-header-text">
      <h1 class="title-primary">Escolha seu perfil</h1>
      <p class="title-primary-description">Selecione o tipo de perfil que melhor representa você ou sua organização</p>
    </div>
  </div>

  <!-- Step Tracker Visual -->
  <div class="step-tracker">
    <div class="step-item" [class.active]="true" [class.completed]="firstFormGroup.valid">
      <div class="step-circle">
        <span *ngIf="!firstFormGroup.valid">1</span>
        <svg *ngIf="firstFormGroup.valid" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 256 256">
          <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
        </svg>
      </div>
      <span class="step-label">Tipo de usuário</span>
    </div>
    <div class="step-connector" [class.active]="firstFormGroup.valid"></div>
    <div class="step-item" [class.active]="firstFormGroup.valid" [class.completed]="secondFormGroup.valid">
      <div class="step-circle">
        <span *ngIf="!secondFormGroup.valid">2</span>
        <svg *ngIf="secondFormGroup.valid" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 256 256">
          <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
        </svg>
      </div>
      <span class="step-label">Escolha o plano</span>
    </div>
    <div class="step-connector" [class.active]="secondFormGroup.valid"></div>
    <div class="step-item" [class.active]="secondFormGroup.valid" [class.completed]="thirdFormGroup.valid">
      <div class="step-circle">
        <span *ngIf="!thirdFormGroup.valid">3</span>
        <svg *ngIf="thirdFormGroup.valid" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 256 256">
          <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
        </svg>
      </div>
      <span class="step-label">Confirmar</span>
    </div>
  </div>

  <!-- ===== PASSO 1: TIPO DE USUÁRIO ===== -->
  <div class="step-section" [class.step-visible]="true">
    <div class="step-section-header">
      <div class="step-number-badge">1</div>
      <h2 class="step-section-title">Você é pessoa física ou jurídica?</h2>
    </div>
    <form [formGroup]="firstFormGroup">
      <div class="type-cards">

        <!-- PF -->
        <div class="type-card" [class.selected]="firstFormGroup.value.userType === 'PF'"
          (click)="firstFormGroup.patchValue({ userType: 'PF' })">
          <div class="type-card-icon">
            <!-- Phosphor: User duotone -->
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#4d8241" viewBox="0 0 256 256">
              <path d="M216,132a88,88,0,1,1-88-88A88,88,0,0,1,216,132Z" opacity="0.2"/>
              <path d="M230.93,220a8,8,0,0,1-6.93,4H32a8,8,0,0,1-6.92-12c15.23-26.33,38.7-45.21,66.09-54.17a72,72,0,1,1,73.66,0C192.23,166.79,215.7,185.67,230.93,212A8,8,0,0,1,230.93,220ZM128,168a56,56,0,1,0-56-56A56.06,56.06,0,0,0,128,168Zm0,16c-30.57,0-56.78,12.62-75.08,34H203.08C184.78,196.62,158.57,184,128,184Z"/>
            </svg>
          </div>
          <div class="type-card-content">
            <h3 class="type-card-title">Pessoa Física</h3>
            <p class="type-card-desc">Profissionais de saúde autônomos, médicos, psicólogos e outros especialistas.</p>
          </div>
          <div class="type-card-check">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
              <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
            </svg>
          </div>
          <input type="radio" formControlName="userType" value="PF" class="hidden-radio">
        </div>

        <!-- PJ -->
        <div class="type-card" [class.selected]="firstFormGroup.value.userType === 'PJ'"
          (click)="firstFormGroup.patchValue({ userType: 'PJ' })">
          <div class="type-card-icon">
            <!-- Phosphor: Buildings duotone -->
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#4d8241" viewBox="0 0 256 256">
              <path d="M240,208H208V96l-80-64L48,96V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Z" opacity="0.2"/>
              <path d="M240,208H224V96a16,16,0,0,0-6.86-13.14l-80-56a16,16,0,0,0-18.28,0l-80,56A16,16,0,0,0,32,96V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM48,96l80-56,80,56V208H160V160a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v48H48Zm96,112H112V168h32Z"/>
            </svg>
          </div>
          <div class="type-card-content">
            <h3 class="type-card-title">Pessoa Jurídica</h3>
            <p class="type-card-desc">Clínicas, hospitais, laboratórios, planos de saúde e outras organizações.</p>
          </div>
          <div class="type-card-check">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
              <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
            </svg>
          </div>
          <input type="radio" formControlName="userType" value="PJ" class="hidden-radio">
        </div>

      </div>
    </form>
  </div>

  <!-- ===== PASSO 2: ESCOLHA DO PLANO ===== -->
  <div class="step-section" [class.step-visible]="firstFormGroup.valid" *ngIf="firstFormGroup.valid">
    <div class="step-section-header">
      <div class="step-number-badge">2</div>
      <h2 class="step-section-title">
        {{ firstFormGroup.value.userType === 'PF' ? 'Selecione seu plano' : 'Qual é o perfil da sua organização?' }}
      </h2>
    </div>
    <form [formGroup]="secondFormGroup">

      <!-- PF: planos do backend -->
      <div *ngIf="firstFormGroup.value.userType === 'PF'" class="plan-cards">
        @for (package of productPackages; track $index) {
          @if (package.active && package.packageType && package.packageType.startsWith('SUBSCRIPTION_PROVIDER_PF')) {
            <div class="plan-card"
              [class.selected]="secondFormGroup.value.plan === package.packageType"
              (click)="secondFormGroup.patchValue({ plan: package.packageType })">

              <div class="plan-card-top">
                <h3 class="plan-card-name">{{ package.name }}</h3>
                @if (package.grossTotal !== 0 && package.finalTotal === 0) {
                  <div class="plan-card-price">
                    <span class="price-original"><del>{{ formatCurrencyValueByMonth(package.grossTotal) }}</del></span>
                    <span class="badge badge-success price-free">Gratuito</span>
                  </div>
                } @else if (package.finalTotal !== 0) {
                  <div class="plan-card-price">
                    <span class="price-value">{{ formatCurrencyValueByMonth(package.finalTotal) }}</span>
                  </div>
                } @else if ((package.grossTotal! - package.finalTotal!) > 0) {
                  <div class="plan-card-price">
                    <span class="price-original"><del>{{ formatCurrencyValueByMonth(package.grossTotal) }}</del></span>
                    <span class="price-value">{{ formatCurrencyValueByMonth(package.finalTotal) }}</span>
                  </div>
                } @else {
                  <div class="plan-card-price">
                    <span class="badge badge-success price-free">Gratuito</span>
                  </div>
                }
              </div>
              <p class="plan-card-desc">{{ package.description }}</p>
              <div class="plan-card-select-indicator">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
                  <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
                  <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
                </svg>
                <span>{{ secondFormGroup.value.plan === package.packageType ? 'Selecionado' : 'Selecionar' }}</span>
              </div>
              <input type="radio" formControlName="plan" [value]="package.packageType" class="hidden-radio">
            </div>
          }
        }
      </div>

      <!-- PJ: categorias fixas -->
      <div *ngIf="firstFormGroup.value.userType === 'PJ'" class="plan-cards">

        <div class="plan-card" [class.selected]="secondFormGroup.value.plan === 'PROVIDER'"
          (click)="secondFormGroup.patchValue({ plan: 'PROVIDER' })">
          <div class="plan-card-top">
            <div class="plan-card-icon">
              <!-- Phosphor: Hospital duotone -->
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#4d8241" viewBox="0 0 256 256">
                <path d="M240,208H216V56a16,16,0,0,0-16-16H56A16,16,0,0,0,40,56V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Z" opacity="0.2"/>
                <path d="M240,200H224V56a24,24,0,0,0-24-24H56A24,24,0,0,0,32,56V200H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM48,56a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V200H160V160a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v40H48Zm96,144H112V168h32Zm-64-96a8,8,0,0,1,8-8h16V80a8,8,0,0,1,16,0V96h16a8,8,0,0,1,0,16H160v16a8,8,0,0,1-16,0V112H128A8,8,0,0,1,120,104Z"/>
              </svg>
            </div>
            <h3 class="plan-card-name">Prestadores</h3>
          </div>
          <p class="plan-card-desc">Hospitais, Clínicas e demais prestadores de serviços de saúde.</p>
          <div class="plan-card-select-indicator">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
              <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
            </svg>
            <span>{{ secondFormGroup.value.plan === 'PROVIDER' ? 'Selecionado' : 'Selecionar' }}</span>
          </div>
          <input type="radio" formControlName="plan" value="PROVIDER" class="hidden-radio">
        </div>

        <div class="plan-card" [class.selected]="secondFormGroup.value.plan === 'CONTRACTOR'"
          (click)="secondFormGroup.patchValue({ plan: 'CONTRACTOR' })">
          <div class="plan-card-top">
            <div class="plan-card-icon">
              <!-- Phosphor: Briefcase duotone -->
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#4d8241" viewBox="0 0 256 256">
                <path d="M224,80V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H216A8,8,0,0,1,224,80Z" opacity="0.2"/>
                <path d="M216,64H176V56a24,24,0,0,0-24-24H104A24,24,0,0,0,80,56v8H40A16,16,0,0,0,24,80V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,56a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,200H40V80H216V200Z"/>
              </svg>
            </div>
            <h3 class="plan-card-name">Contratante</h3>
          </div>
          <p class="plan-card-desc">Planos de Saúde, Empresas e Instituições contratantes.</p>
          <div class="plan-card-select-indicator">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
              <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
            </svg>
            <span>{{ secondFormGroup.value.plan === 'CONTRACTOR' ? 'Selecionado' : 'Selecionar' }}</span>
          </div>
          <input type="radio" formControlName="plan" value="CONTRACTOR" class="hidden-radio">
        </div>

        <div class="plan-card" [class.selected]="secondFormGroup.value.plan === 'PROVIDER_CONTRACTOR'"
          (click)="secondFormGroup.patchValue({ plan: 'PROVIDER_CONTRACTOR' })">
          <div class="plan-card-top">
            <div class="plan-card-icon">
              <!-- Phosphor: ArrowsLeftRight duotone -->
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#4d8241" viewBox="0 0 256 256">
                <path d="M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z" opacity="0.2"/>
                <path d="M237.66,181.66l-32,32a8,8,0,0,1-11.32-11.32L212.69,184H43.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L43.31,168H212.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,237.66,181.66Zm-96-72H212.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32-11.32L212.69,128H141.66l-18.35,18.34A8,8,0,0,1,112,128V64a8,8,0,0,1,13.66-5.66Z"/>
              </svg>
            </div>
            <h3 class="plan-card-name">Contratante e Prestador</h3>
          </div>
          <p class="plan-card-desc">Organizações que atuam simultaneamente como contratante e prestador.</p>
          <div class="plan-card-select-indicator">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
              <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
            </svg>
            <span>{{ secondFormGroup.value.plan === 'PROVIDER_CONTRACTOR' ? 'Selecionado' : 'Selecionar' }}</span>
          </div>
          <input type="radio" formControlName="plan" value="PROVIDER_CONTRACTOR" class="hidden-radio">
        </div>

        <div class="plan-card" [class.selected]="secondFormGroup.value.plan === 'SUBSCRIPTION_LAB'"
          (click)="secondFormGroup.patchValue({ plan: 'SUBSCRIPTION_LAB' })">
          <div class="plan-card-top">
            <div class="plan-card-icon">
              <!-- Phosphor: Flask duotone -->
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#4d8241" viewBox="0 0 256 256">
                <path d="M224,192l-71.6-88H103.6L32,192Z" opacity="0.2"/>
                <path d="M221.18,188.59,160,108.18V48h8a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h8V108.18L34.82,188.59A16,16,0,0,0,48,216H208a16,16,0,0,0,13.18-27.41ZM112,115.13V48h32V115.13l17.08,20.87H94.92Z"/>
              </svg>
            </div>
            <h3 class="plan-card-name">Laboratório</h3>
          </div>
          <p class="plan-card-desc">Laboratórios de análises clínicas e de diagnóstico por imagem.</p>
          <div class="plan-card-select-indicator">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
              <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
            </svg>
            <span>{{ secondFormGroup.value.plan === 'SUBSCRIPTION_LAB' ? 'Selecionado' : 'Selecionar' }}</span>
          </div>
          <input type="radio" formControlName="plan" value="SUBSCRIPTION_LAB" class="hidden-radio">
        </div>

        <div class="plan-card" [class.selected]="secondFormGroup.value.plan === 'SUBSCRIPTION_ADMINISTRATOR'"
          (click)="secondFormGroup.patchValue({ plan: 'SUBSCRIPTION_ADMINISTRATOR' })">
          <div class="plan-card-top">
            <div class="plan-card-icon">
              <!-- Phosphor: ShieldStar duotone -->
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#4d8241" viewBox="0 0 256 256">
                <path d="M216,48V152a88,88,0,0,1-88,88A88,88,0,0,1,40,152V48Z" opacity="0.2"/>
                <path d="M208,40H48A16,16,0,0,0,32,56V152a96.09,96.09,0,0,0,96,96,96.09,96.09,0,0,0,96-96V56A16,16,0,0,0,208,40Zm0,112a80,80,0,0,1-160,0V56H208Zm-40.22-92.22L152,66.54l-15.78,15.78A8,8,0,0,1,124.9,71l15.78-15.78a16,16,0,0,1,22.64,0l15.78,15.78a8,8,0,0,1-11.32,11.32ZM128,96a8,8,0,0,1,8,8v40l13.66,13.66a8,8,0,0,1-11.32,11.32L124.69,155.31A8,8,0,0,1,122,149.65V104A8,8,0,0,1,128,96Z"/>
              </svg>
            </div>
            <h3 class="plan-card-name">Administradores</h3>
          </div>
          <p class="plan-card-desc">Associações, Conselhos e entidades administrativas da área da saúde.</p>
          <div class="plan-card-select-indicator">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
              <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
              <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
            </svg>
            <span>{{ secondFormGroup.value.plan === 'SUBSCRIPTION_ADMINISTRATOR' ? 'Selecionado' : 'Selecionar' }}</span>
          </div>
          <input type="radio" formControlName="plan" value="SUBSCRIPTION_ADMINISTRATOR" class="hidden-radio">
        </div>

      </div>
    </form>
  </div>

  <!-- ===== PASSO 3: PACOTE ESPECÍFICO (PJ não-administrador) ===== -->
  <div class="step-section"
    *ngIf="secondFormGroup.valid && ['PROVIDER','CONTRACTOR','PROVIDER_CONTRACTOR','SUBSCRIPTION_LAB'].includes(secondFormGroup.value.plan ?? '')">
    <div class="step-section-header">
      <div class="step-number-badge">3</div>
      <h2 class="step-section-title">Especifique o pacote</h2>
    </div>
    <form [formGroup]="thirdFormGroup">
      <div class="plan-cards">

        @for (package of productPackages; track $index) {
          @if (
            package.active && package.packageType && (
              (secondFormGroup.value.plan === 'PROVIDER' && package.packageType.startsWith('SUBSCRIPTION_PROVIDER_PJ')) ||
              (secondFormGroup.value.plan === 'CONTRACTOR' && package.packageType.startsWith('SUBSCRIPTION_CONTRACTOR_PJ')) ||
              (secondFormGroup.value.plan === 'PROVIDER_CONTRACTOR' && package.packageType.startsWith('SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ')) ||
              (secondFormGroup.value.plan === 'SUBSCRIPTION_LAB' && package.packageType.startsWith('SUBSCRIPTION_LAB'))
            )
          ) {
            <div class="plan-card"
              [class.selected]="thirdFormGroup.value.package === package.packageType"
              (click)="thirdFormGroup.patchValue({ package: package.packageType })">

              <div class="plan-card-top">
                <h3 class="plan-card-name">{{ package.name }}</h3>
                @if (package.grossTotal !== 0 && package.finalTotal === 0) {
                  <div class="plan-card-price">
                    <span class="price-original"><del>{{ formatCurrencyValueByMonth(package.grossTotal) }}</del></span>
                    <span class="badge badge-success price-free">Gratuito</span>
                  </div>
                } @else if (package.finalTotal !== 0) {
                  <div class="plan-card-price">
                    <span class="price-value">{{ formatCurrencyValueByMonth(package.finalTotal) }}</span>
                  </div>
                } @else if ((package.grossTotal! - package.finalTotal!) > 0) {
                  <div class="plan-card-price">
                    <span class="price-original"><del>{{ formatCurrencyValueByMonth(package.grossTotal) }}</del></span>
                    <span class="price-value">{{ formatCurrencyValueByMonth(package.finalTotal) }}</span>
                  </div>
                } @else {
                  <div class="plan-card-price">
                    <span class="badge badge-success price-free">Gratuito</span>
                  </div>
                }
              </div>
              <p class="plan-card-desc">{{ package.description }}</p>
              <div class="plan-card-select-indicator">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
                  <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
                  <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"/>
                </svg>
                <span>{{ thirdFormGroup.value.package === package.packageType ? 'Selecionado' : 'Selecionar' }}</span>
              </div>
              <input type="radio" formControlName="package" [value]="package.packageType" class="hidden-radio">
            </div>
          }
        }

      </div>
    </form>
  </div>

  <!-- Espaço final -->
  <div style="height: 48px;"></div>
</div>